let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6X94G")).then(() => parcelRequire('9YtPn'));